import { Maximize2, X } from "lucide-react";

export function ChartExpandButton({ onClick, label = "Expand chart" }) {
  return (
    <button type="button" className="btn btn-sm btn-ghost chart-expand-btn" onClick={onClick} aria-label={label} title={label}>
      <Maximize2 size={14} />
    </button>
  );
}

export default function ChartExpandModal({ open, title, subtitle, onClose, children }) {
  if (!open) return null;
  return (
    <div className="modal-overlay chart-expand-overlay" onClick={onClose} role="presentation">
      <div
        className="modal chart-expand-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="modal-header chart-expand-header">
          <div>
            <div className="modal-title">{title}</div>
            {subtitle ? <p className="chart-expand-subtitle">{subtitle}</p> : null}
          </div>
          <button type="button" className="btn btn-sm" onClick={onClose} aria-label="Close">
            <X size={14} style={{ marginRight: 4 }} />
            Close
          </button>
        </div>
        <div className="chart-expand-body">{children}</div>
      </div>
    </div>
  );
}
